let activeScroller = null;

// Posición inicial del slider en todas las secciones
document.querySelectorAll('.scroller').forEach(scroller => {
  const wrapper = scroller.closest('.wrapper');
  const after = wrapper.querySelector('.after');
  scrollIt(scroller, after, wrapper, 150);
});


// Función para actualizar la posición del slider en su sección correspondiente
function scrollIt(scroller, after, wrapper, x) {
    let transform = Math.max(0, Math.min(x, wrapper.offsetWidth));
    after.style.width = transform + "px";
    scroller.style.left = transform - 25 + "px";
}

// Manejador para eventos de inicio (mouse y touch)
function startScroll(e) {
    activeScroller = this;
    activeScroller.classList.add('scrolling');

    // Encontrar los elementos relacionados con este scroller
    const wrapper = activeScroller.closest('.wrapper');
    const after = wrapper.querySelector('.after');

    // Guardar los elementos relacionados en el scroller
    activeScroller.wrapper = wrapper;
    activeScroller.after = after;
}

// Manejador para eventos de finalización (mouse y touch)
function stopScroll() {
    if (!activeScroller) return;
    activeScroller.classList.remove('scrolling');
    activeScroller = null;
}

// Manejador para movimiento (mouse y touch)
function moveScroll(e) {
    if (!activeScroller) return;

    let x;
    if (e.touches) {
        x = e.touches[0].clientX;
    } else {
        x = e.pageX;
    }

    x -= activeScroller.wrapper.getBoundingClientRect().left;
    scrollIt(activeScroller, activeScroller.after, activeScroller.wrapper, x);
}

// Seleccionar todos los scrollers y agregar eventos
document.querySelectorAll('.scroller').forEach(scroller => {
    scroller.addEventListener('mousedown', startScroll);
    scroller.addEventListener('touchstart', startScroll);
});

// Agregar eventos globales para detectar movimiento y soltar
document.body.addEventListener('mouseup', stopScroll);
document.body.addEventListener('mouseleave', stopScroll);
document.body.addEventListener('mousemove', moveScroll);
document.body.addEventListener('touchend', stopScroll);
document.body.addEventListener('touchcancel', stopScroll);
document.body.addEventListener('touchmove', moveScroll, { passive: false });

